import { NoopLogger } from '../noop-logger';

export const fallbackLogger = new NoopLogger();
